import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import './List.css';
import '../App.css';
import { createStyles, makeStyles, Snackbar, Theme } from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import { SelectIcon } from '../components/parts/cloudStorage/SelectIcon';
import { LinkSendButton } from '../components/parts/cloudStorage/style/style';
import { useHistory } from 'react-router-dom';
import {
  documentDownloadLogin,
  getDownloadDocument
} from '../apicalls/documentExternalSharePage';
import { TDownloadDocument } from '../types/DocumentExternalSharePage';
import LoadingComponent from '../components/LoadingComponent';
import { DOCUMENT_TYPE } from '../const/Const';

export const DocumentExternalSharePage: React.FC = () => {
  // 共有されている資料
  const [downloadDocument, setDownloadDocument] = useState<TDownloadDocument>();

  // エラーメッセージ表示フラグ
  const [isError, setIsError] = useState(false);
  // エラーメッセージ
  const [errorMessage, setErrorMessage] = useState('');

  const [dispFlg, setDispFlg] = useState<boolean>(false);

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsError(false);
  };

  // URLのuidとpwdを取得
  const location = useLocation();
  const search = location.search;
  const query = new URLSearchParams(search);
  const uid = query.get('uid') as string;
  const pwd = query.get('pwd') as string;
  const history = useHistory();

  useEffect(() => {
    // ローディング表示
    setLoading(true);

    // 共有先を認証し、アクセストークンをセット
    documentDownloadLogin(uid, pwd)
      .then(res => {
        if (res.data) {
          setIsError(true);
          setErrorMessage(res.data.error);
          setOpen(true);
        } else {
          // 書類情報取得
          getDownloadDocument().then(async data => {
            if (typeof data === 'string') {
              setIsError(true);
              setErrorMessage(data);
              setOpen(true);
            } else {
              if (data.error) {
                setIsError(true);
                setErrorMessage(data.error);
                setOpen(true);
              } else {
                setDownloadDocument(data);
                setDispFlg(true);
              }
            }
          });
        }
      })
      .finally(() => {
        // ローディング非表示
        setLoading(false);
      });
  }, []);

  // 書類を開くボタン押下
  const onClickBtn = () => {
    // 書類データが存在する場合
    if (downloadDocument) {
      // 見積書(1)
      if (downloadDocument.document_type == DOCUMENT_TYPE.ESTIMATE) {
        history.replace(
          `/download/estimate/${downloadDocument.type_document_id}/preview`,
          {
            document_id: downloadDocument.document_id,
            backPath: location.pathname + search
          }
        );
        // 請求書(2)
      } else if (downloadDocument.document_type == DOCUMENT_TYPE.INVOICE) {
        history.replace(
          `/download/invoice/${downloadDocument.type_document_id}/preview`,
          {
            document_id: downloadDocument.document_id,
            backPath: location.pathname + search
          }
        );
        // 商品発注書(4)
      } else if (
        downloadDocument.document_type == DOCUMENT_TYPE.MERCHANDISE_ORDER
      ) {
        history.replace(
          `/download/product/purchase/${downloadDocument.type_document_id}/preview`,
          {
            document_id: downloadDocument.document_id,
            backPath: location.pathname + search
          }
        );
        // 外注発注書(5)
      } else if (
        downloadDocument.document_type == DOCUMENT_TYPE.OUTSOURCE_ORDER
      ) {
        history.replace(
          `/download/outsource/${downloadDocument.type_document_id}/preview`,
          {
            document_id: downloadDocument.document_id,
            backPath: location.pathname + search
          }
        );
        // 現場連絡表(8)
      } else if (downloadDocument.document_type == DOCUMENT_TYPE.SITE_CONTACT) {
        history.replace(
          `/download/sitecontact/${downloadDocument.type_document_id}/preview`,
          {
            document_id: downloadDocument.document_id,
            backPath: location.pathname + search
          }
        );
      }
    }
  };

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      table: {
        paddingTop: 16,
        paddingBottom: 16
      }
    })
  );

  const classes = useStyles();

  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={4000}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
    >
      <div style={{ backgroundColor: '#F5F5F5' }}>
        {/* ヘッダー */}
        <AppBarComponent isDocumentDownloadPage={true} />
        {loading ? (
          <>
            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
              <Alert onClose={handleClose} severity='error'>
                {errorMessage}
              </Alert>
            </Snackbar>
            <LoadingComponent />
          </>
        ) : (
          <div
            style={{
              backgroundColor: '#F5F5F5',
              padding: 15,
              minHeight: window.innerHeight - 120,
              display: 'flex',
              justifyContent: 'center',
              textAlign: 'left',
              alignItems: 'center',
              flexDirection: 'column'
            }}
          >
            <div>
              <h2
                style={{
                  textAlign: 'center',
                  marginBottom: 30
                }}
              >
                書類ダウンロード
              </h2>
              <table cellPadding='10'>
                <tr className={classes.table}>
                  <td>書類</td>
                  <td>
                    {dispFlg && (
                      <SelectIcon
                        width={31}
                        height={38}
                        format={'application/pdf'}
                        name={'sample.pdf'}
                      />
                    )}
                    {dispFlg ? downloadDocument?.document_name : '-'}
                  </td>
                </tr>
                <tr className={classes.table}>
                  <td>送付先</td>
                  <td>
                    {dispFlg
                      ? `${downloadDocument?.to_company_name} ${downloadDocument?.to_name}様`
                      : '-'}
                  </td>
                </tr>
                <tr className={classes.table}>
                  <td>送信日時</td>
                  <td>{dispFlg ? downloadDocument?.sent_datetime : '-'}</td>
                </tr>
                <tr className={classes.table}>
                  <td>送信元</td>
                  <td>
                    {dispFlg
                      ? `${downloadDocument?.sender_company_name} ${downloadDocument?.sender_user_name}`
                      : '-'}
                  </td>
                </tr>
              </table>
            </div>
            <div style={{ marginTop: 30 }}>
              <LinkSendButton
                variant='contained'
                onClick={() => onClickBtn()}
                disabled={!dispFlg}
              >
                書類を開く
              </LinkSendButton>
            </div>
          </div>
        )}

        {/* フッター */}
        <FooterComponent />
      </div>

      {/* エラーメッセージ */}
      {/* MUIのSnackbar ※notistack（ライブラリ）のSnackbarProviderは無関係 */}
      <Snackbar open={isError} autoHideDuration={4000} onClose={handleClose}>
        <Alert onClose={handleClose} severity='error'>
          {errorMessage}
        </Alert>
      </Snackbar>
    </SnackbarProvider>
  );
};
